export class Dish {
  constructor(id, name, description, isDefault) {
    if (id || id === 0) this.id = id;

    if (name) this.name = name;
    else this.name = '';

    if (description) this.description = description;
    else this.description = '';

    this.isDefault = !!isDefault
    this.selected = this.isDefault;
  }
}

export class Menu {
  constructor() {
    this.categories = [];
    this.name = '';
    this.description = '';
  }

  map(menu) {
    this.id = menu.id;
    this.name = menu.name;
    this.description = menu.description;
    this.categories = menu.categories.map(category => new MenuCategory().map(category));

    return this;
  }
}

export class MenuCategory {
  constructor() {
    this.name = '';
    this.description = '';
    this.items = [];
    this.defaultItemId = null;
  }

  map(category) {
    this.id = category.id;
    this.name = category.name;
    this.description = category.description;
    this.position = category.position;
    this.quantity = category.items_quantity;
    this.image = category.image;
    this.items = category.items.map(menuItem => {
      if (menuItem.is_default) this.selectDefaultMenuItem(menuItem.id);
      return new MenuItem().map(menuItem)
    });

    return this;
  }

  selectDefaultMenuItem(id) {
    this.defaultItemId = id;

    this.items.forEach(item => {
      item.isDefault = item.id === id;
    })
  }

  isMenuItemDefault(id) {
    return this.defaultItemId && this.defaultItemId === id;
  }
}

export class MenuItem {
  constructor() {
    this.name = '';
    this.description = '';
    this.isDefault = false;
    this.price = 0;
    this.position = 0;
    this.selected = false;
    this.image = null;
  }

  map(item) {
    this.id = item.id;
    this.name = item.name;
    this.description = item.description;
    this.isDefault = !!item.is_default;
    this.price = item.price;
    this.position = item.position;
    this.categoryId = item.category_id;
    this.image = item.image;
    this.selected = !!item.is_default;

    return this;
  }

  select() {
    this.selected = true;
  }

  unselect() {
    this.selected = false;
  }
}
